import { HashRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ConditionsAndTerms from "./pages/ConditionsAndTerms";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="font-tajawal bg-landingPage">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/terms-and-conditions"
            element={<ConditionsAndTerms />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
